import { createContext, useContext } from 'react'
import { Screen } from 'common/types'

interface ScreenContainerProps {
  screen: Partial<Screen>
  children: React.ReactNode
}

export const ScreenContext = createContext<Partial<Screen> | undefined>(undefined)
export function useScreen() {
  return useContext(ScreenContext)
}

export const ScreenContainer: React.FC<ScreenContainerProps> = ({ children, screen }) => {
  const angle = screen.orientation || '0'

  let transform = ''
  let transformOrigin = ''
  let width = '100%'
  let height = '100%'

  if (angle === '90' || angle === '270') {
    const translate = angle === '90' ? 'translateY(-100%)' : 'translateX(-100%)'
    transform = `rotate(${angle}deg) ${translate}`
    transformOrigin = 'top left'
    width = `${window.innerHeight}px`
    height = `${window.innerWidth}px`
  } else {
    transform = `rotate(${angle}deg)`
    transformOrigin = 'center'
  }

  return (
    <ScreenContext.Provider value={screen}>
      <div
        className="relative"
        style={{
          transform,
          transformOrigin,
          width,
          height,
        }}
      >
        {children}
      </div>
    </ScreenContext.Provider>
  )
}
